import React, { useContext, memo } from "react";
import SettingsContext from "src/context/SettingsContext";
import { Box, makeStyles } from "@material-ui/core";

// Move styles outside component to prevent recreation on each render
const useStyles = makeStyles((theme) => ({
  logoBox: {
    "& img": {
      marginRight: theme.spacing(2),
      width: "auto", // Explicit dimensions help browser allocate space before image loads
      height: "auto",
      maxHeight: "40px", // Adjust based on your actual logo size
    },
  },
  mobHide: {
    display: "block",
    "@media (max-width: 600px)": {
      display: "none",
    },
  },
  deskHide: {
    display: "none",
    "@media (max-width: 600px)": {
      display: "block",
    },
  },
}));

// Create image URLs once outside component
const getImageUrl = (imageName) => {
  const isDevelopment = process.env.REACT_APP_ENV === "development";
  const adjustedImageName = isDevelopment
    ? imageName.replace(".svg", "_beta.svg")
    : imageName;
  return `${process.env.REACT_APP_IMAGE_BASE_URL}/${adjustedImageName}`;
};

const Logo = ({ style }) => {
  const { settings } = useContext(SettingsContext);
  const classes = useStyles();

  const isDarkTheme = settings.theme === "DARK";
  const logoUrl = isDarkTheme
    ? getImageUrl("logo_light.svg")
    : getImageUrl("logo_dark.svg");
  const mobileLogoUrl = logoUrl;

  return (
    <>
      <div className={classes.mobHide}>
        <Box className={classes.logoBox}>
          <img
            src={logoUrl}
            alt="Blockstats Logo"
            loading="eager"
            fetchpriority="high"
            width="178"
            height="40"
            decoding="async"
          />
        </Box>
      </div>
      <div className={classes.deskHide}>
        <img
          src={mobileLogoUrl}
          alt="Blockstats Logo"
          loading="eager"
          fetchpriority="high"
          style={style}
        />
      </div>
    </>
  );
};

export default memo(Logo);